export var onChangeCheckedHandler = function (callback) {
    return function (event) {
        callback(event, event.target.checked);
    };
};
export var onChangeValueHandler = function (callback, value) {
    return function (event) {
        callback(event, value);
        event.target.blur();
    };
};
//# sourceMappingURL=eventHandler.js.map